import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { refreshInventory } from "form/inventory/tools/common"
import { IForm } from "form/model"
import { formActionCreator } from "form/store/actions"
import { getCreativeChange } from "form/tools/creative"
import { CreativeUploadPopup } from "media/components/CreativeUploadPopup"
import { IMediaUploadParams } from "media/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface ICreativeCampaignUploadButtonProps {
  form: IForm
  params: IMediaUploadParams
}

export const CreativeCampaignUploadButton = React.memo(({ form, params }: ICreativeCampaignUploadButtonProps) => {
  const [isPopupOpened, setIsPopupOpened] = React.useState(false)
  return (
    <>
      {isPopupOpened && (
        <CreativeUploadPopup
          params={params}
          onClose={() => setIsPopupOpened(false)}
          onUploadSuccess={newMedia => {
            const newMedias = [...form.creatives.medias, newMedia]
            getStore().dispatch(
              formActionCreator.setCreatives(
                form.context.appContext,
                {
                  // use getForm because medias have changed since we did the first getForm
                  medias: newMedias
                },
                getCreativeChange(form, newMedias)
              )
            )
            setIsPopupOpened(false)
            refreshInventory()
          }}
        />
      )}
      <FlexBox
        gap=".5rem"
        onClick={() => setIsPopupOpened(true)}
        sx={{ "cursor": "pointer", "& .icon": { color: theme => theme.palette.primary.main, fontSize: "1.2rem" } }}>
        <FontAwesomeIcon icon={faCirclePlus} className="icon" />
        <Typography fontSize=".8rem" fontWeight={600} sx={{ color: theme => theme.palette.primary.main }}>
          {translate("media.creative.add")}
        </Typography>
      </FlexBox>
    </>
  )
})
